import { useState } from 'react'
import styles from "../../analytics.module.css"

const CreateAlertModal = ({setShowCreateModal, handleCreateAlert}) => {
	const [newAlert, setNewAlert] = useState({
		title: "",
		message: "",
		alertType: "system",
		severity: "normal",
		priority: 3,
	})
	const [loading, setLoading] = useState(false)
	
	const onSubmit = async () => {
		setLoading(true)
		await handleCreateAlert(newAlert)
		setLoading(false)
	}

	return (
		<div className={styles.modalOverlay} onClick={() => setShowCreateModal(false)}>
			<div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
				<div className={styles.modalHeader}>
					<h2>Create New Alert</h2>
					<button className={styles.closeButton} onClick={() => setShowCreateModal(false)}>
						×
					</button>
				</div>


				<div className={styles.formGroup}>
					<label>Title *</label>
					<input
						type="text"
						value={newAlert.title}
						onChange={(e) => setNewAlert({ ...newAlert, title: e.target.value })}
						placeholder="Alert title"
						required
					/>
				</div>

				<div className={styles.formGroup}>
					<label>Message *</label>
					<textarea
						value={newAlert.message}
						onChange={(e) => setNewAlert({ ...newAlert, message: e.target.value })}
						placeholder="Alert message"
						rows={4}
						required
					/>
				</div>

				<div className={styles.formGroup}>
					<label>Alert Type</label>
					<select
						value={newAlert.alertType}
						onChange={(e) => setNewAlert({ ...newAlert, alertType: e.target.value })}
					>
						<option value="system">System</option>
						<option value="profit">Profit</option>
						<option value="cost">Cost</option>
						<option value="orders">Orders</option>
						<option value="supplier">Supplier</option>
						<option value="security">Security</option>
					</select>
				</div>

				<div className={styles.formGroup}>
					<label>Severity</label>
					<select
						value={newAlert.severity}
						onChange={(e) => setNewAlert({ ...newAlert, severity: e.target.value })}
					>
						<option value="normal">Normal</option>
						<option value="warning">Warning</option>
						<option value="critical">Critical</option>
					</select>
				</div>

				<div className={styles.formGroup}>
					<label>Priority (1-10)</label>
					<input
						type="number"
						min="1"
						max="10"
						value={newAlert.priority}
						onChange={(e) => setNewAlert({ ...newAlert, priority: Number.parseInt(e.target.value) })}
					/>
				</div>

				<button onClick={onSubmit} className={styles.primaryButton}>
					{loading ? "Creating..." : "Create Alert"}
				</button>
			</div>
		</div>
	)
}

export default CreateAlertModal